import { NextPage } from 'next';

export enum Layouts {
  LoggedOut = 'LoggedOut',
  LoggedInFullBleed = 'LoggedInFullBleed',

  // Sidebar inherits all of LoggedIn and then also renders a Sidebar.
  // We may refactor this later.
  LoggedInSidebar = 'LoggedInSidebar',

  Finance = 'Finance',

  /**
   * A custom layout for the Emissions Factors pages on logged in dashboard, to provide some shared state
   */
  EmissionsFactors = 'EmissionsFactors',

  /**
   * A custom layout for the Settings pages on logged in dashboard, to provide a more beautiful
   * and entirely superior sidebar
   */
  Settings = 'Settings',

  /**
   * A custom layout for pages that need CoPilot functionality, duplicated from SidebarLayout
   */
  CoPilot = 'CoPilot',
}

export type NextPageWithLayout = NextPage & {
  layout?: Layouts;
};
